<template>
    <div
        class="flex justify-between min-w-0 w-full h-[133px] rounded-[5px] shadow-sm overflow-hidden bg-white"
    >
        <div class="p-0 flex items-center mx-4 w-full">
            <div class="flex justify-start w-1/3">
                <img
                    v-if="data.icon == 'Impressions'"
                    src="../../../assets/Gif/ad-loops.gif"
                    class="w-[75px] h-[75px]"
                    alt=""
                />
                <img
                    v-if="data.icon == 'DistanceCovered'"
                    src="../../../assets/Gif/distance-covered.gif"
                    class="w-[75px] h-[75px]"
                />
                <img
                    v-if="data.icon == 'budget'"
                    src="../../../assets/Gif/budget.gif"
                    class="w-[75px] h-[75px]"
                />
                <img
                    v-if="data.icon == 'cpm'"
                    src="../../../assets/Gif/cpm.gif"
                    class="w-[75px] h-[75px]"
                />
            </div>
            <div class="flex flex-col w-2/3 items-center">
                <p class="mb-2 text-[16px] font-normal text-black 0">
                    {{ data.name }}
                </p>
                <p class="text-[26px] font-bold">
                    {{ data.value.toLocaleString() }}
                </p>
                <p class="mb-2 text-[16px] font-medium text-primary">
                    {{ data.info }}
                </p>
            </div>
        </div>
        <div class="mr-5 mt-5">
            <tool-tip
                v-if="data.icon == 'Impressions'"
                title="Ad Loop"
                discription="How many times your ad will be played, each Ad Loop is 30 seconds."
            >
            </tool-tip>
            <tool-tip
                v-if="data.icon == 'DistanceCovered'"
                title="Distance Covered"
                discription="How many kilometers covered with your ad on."
            >
            </tool-tip>
            <!-- <tool-tip
                v-if="data.icon == 'budget'"
                title="budget"
                discription="How many times your ad will be played, each ad loop is 30 seconds."
            >
            </tool-tip> -->
            <tool-tip
                v-if="data.icon == 'cpm'"
                title="CPM"
                discription="Is the cost for 1,000 Ad views while played on our screens."
            >
            </tool-tip>
        </div>
    </div>
</template>

<script>
import ToolTip from "../ToolTip.vue";
export default {
    components: { ToolTip },
    props: {
        data: {
            name: "",
            value: "",
            icon: "",
            info: "",
        },
    },
};
</script>

<style></style>
